import { motion } from "framer-motion";

export default function PageHeader({ overline, title, subtitle, image }) {
  return (
    <section className="relative pt-[110px] pb-14 border-b border-border overflow-hidden">
      {image && (
        <div className="absolute inset-0 z-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-20 dark:opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/40" />
        </div>
      )}
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 lg:px-8">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          className="text-xs uppercase tracking-[0.25em] text-primary font-bold mb-4">{overline}</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="font-display font-900 uppercase text-5xl sm:text-6xl md:text-7xl leading-[0.9] tracking-tighter">
          {title}
        </motion.h1>
        {subtitle && <p className="mt-5 text-muted-foreground text-base lg:text-lg max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}
